"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = require("styled-components");
const i18n_1 = require("@completeanatomy/i18n");
const hooks_1 = require("../../hooks");
const index_1 = require("../index");
function RejectAdminButton({ membershipId }) {
    const sharingService = (0, hooks_1.useSharing)();
    const theme = (0, styled_components_1.useTheme)();
    const onRetractAdminPermissions = () => {
        sharingService === null || sharingService === void 0 ? void 0 : sharingService.retractAdmin(membershipId);
    };
    return ((0, jsx_runtime_1.jsx)(index_1.StyledMemberButton, { "$backgroundColor": theme.green, "$color": theme.white, onClick: onRetractAdminPermissions, "data-e2e": 'RejectAdminButton_StyledMemberButton', children: (0, i18n_1.Localized)(i18n_1.Strings.groups.edit.members.rejectAdmin) }));
}
exports.default = RejectAdminButton;
